import { updateOrderCity, senditCreateParcel, senditTracking } from "./auth";

// Sendit passe désormais par delivery_service (POST /sendit/shipments/add/,
// GET /sendit/shipments/tracking/) : plus de login Sendit ni de clé privée
// dans le navigateur. Les noms exportés sont conservés pour les appelants.

export const add_orders_sendit = async (data, defaultagencyLivraison) => {
  const res = await senditCreateParcel({
    ...data,
    connection_id: defaultagencyLivraison?.id || undefined,
  });

  // Filet de sécurité si la synchro Orders côté backend a échoué
  const ordersOk = res?.orders_updates?.delivery?.ok && res?.orders_updates?.status?.ok;
  if (res?.tracking_number && res?.orders_updates && !ordersOk) {
    try {
      await updateOrderCity(data.order_id, {
        shipping_status: res.current_status,
        delivery_agency_id: "SENDIT",
        delivery_tracking_id: res.tracking_number,
      });
    } catch (syncError) {
      console.error("Sendit: order sync fallback failed", syncError?.response?.data || syncError);
    }
  }
  return res;
};

// Renvoie la réponse Sendit brute ({ data: {...} }) attendue par
// normalizeSenditTrackingResponse (trackingProviders.js).
export const sendit_traking = async (trackingNumber, defaultagencyLivraison) => {
  try {
    const res = await senditTracking(trackingNumber, defaultagencyLivraison?.id);
    return res?.sendit_response || null;
  } catch (err) {
    console.error("Sendit tracking error:", err?.response?.data || err);
    return null;
  }
};
